import { render, staticRenderFns } from "./AfOcHeader.vue?vue&type=template&id=1fc62532&scoped=true"
import script from "./AfOcHeader.vue?vue&type=script&lang=ts"
export * from "./AfOcHeader.vue?vue&type=script&lang=ts"
import style0 from "./AfOcHeader.vue?vue&type=style&index=0&id=1fc62532&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc62532",
  null
  
)

export default component.exports